






































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import pluralize from '@/modules/shared/filters/pluralize.filter';

import TableComponent, { TableHeader } from '@/modules/shared/components/table.component.vue';
import RankingCircle, { RankingCircleOption, IconEnum } from '@/modules/shared/components/ranking-circle.component.vue';

import { User } from '@/modules/user/model/user.model';
import Seller from '@/modules/user/model/seller.model';



@Component({
    components: {
        TableComponent,
        RankingCircle,
    },
    computed: {
        ...mapGetters({
            pursuersList: 'getPursuersList',
            availablePoints: 'getAvailablePoints',
            profile: 'getProfile',
        }),
    },
    methods: {
        ...mapActions({
            fetchPursuersList: 'fetchPursuersList',
        }),
    },
    filters: {
        pluralize,
    },
})
export default class NationalPosition extends Vue {
    private pursuersList!: any[];
    private availablePoints!: number;
    private fetchPursuersList!: any;
    private profile!: User;
    private literals = {
        title: 'Posición nacional',
        rightSection: 'Perseguidores',
        point: 'punto',
        points: 'puntos',
        consolidated: 'Consolidados',
        provisional: 'Provisionales',
        pursuersListEmpty: 'No tienes perseguidores en este momento',
    };
    private headers: TableHeader[] = [
        {
            key: 'name',
            value: 'Vendedor',
        }, {
            key: 'position',
            value: 'Posición',
        }, {
            key: 'points',
            value: 'Sobrepaso en',
        },
    ];


    private created() {
        this.fetchPursuersList();
    }


    get list() {
        return this.pursuersList.map((pursuer: any) => {
            return {
                position: pursuer.rankingPosition,
                points: this.differencePoints(pursuer.pointsConsolidated),
                name: pursuer.sellerCode,
            };
        });
    }

    get options(): RankingCircleOption[] {
        return this.pursuersList.map((pursuer: any, index: number) => {
            return {
                position: pursuer.rankingPosition,
                name: pursuer.sellerCode,
                icon: this.getBadgeIcon(index),
                active: (index === 0),
            };
        });
    }

    get pointsEarned(): number {
        return Math.round( ((this.profile as User).seller as Seller).pointsObtained);
    }

    get profileName() {
        return `${this.profile.firstName} ${this.profile.lastName}`;
    }


    private differencePoints(points: number) {
        const calc = Math.abs(this.pointsEarned - points);
        return (this.$options.filters as any).pluralize(Math.round(calc), 'pt', 'pts');
    }

    private getBadgeIcon(index: number) {
        let icon = IconEnum.VerySatisfied;
        if (index === 1) {
            icon = IconEnum.Satisfied;
        } else if ( index === 2 ) {
            icon = IconEnum.VeryDissatisfied;
        }
        return icon;
    }
}
